import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithAuth } from "./hrmsNotifications";
import Apis from "../../utils/apis";

export const userApi = createApi({
  reducerPath: "user",
  baseQuery: baseQueryWithAuth,
  tagTypes: ["User"],
  endpoints: (builder) => ({
    getUserData: builder.query({
      query: ({ page = 1, search }) => ({
        url: Apis.hrmsUser,
        params: {
          page,
          search,
        },
      }),
      providesTags: ["User"],
      //   transformResponse: (res) => res,
      keepUnusedDataFor: 180,
    }),
  }),
});

export const { useGetUserDataQuery } = userApi;

export const inactiveApi = createApi({
  reducerPath: "inactiveuser",
  baseQuery: baseQueryWithAuth,
  tagTypes: ["Inactive"],
  endpoints: (builder) => ({
    getInactiveData: builder.query({
      query: ({ page = 1, role, search, limit = 10 }) => ({
        url: Apis.inactiveUser,
        params: {
          page,
          role,
          search,
          limit,
        },
      }),
      providesTags: ["Inactive"],
      keepUnusedDataFor: 300,
    }),
  }),
});

export const { useGetInactiveDataQuery } = inactiveApi;

export const hierarchyUsersApi = createApi({
  reducerPath: "hierarchyUsers",
  baseQuery: baseQueryWithAuth,
  tagTypes: ["hierarchyUsers"],
  endpoints: (builder) => ({
    hierarchyUsersData: builder.query({
      query: () => ({
        url: Apis.hierarchyUsers,
      }),
      providesTags: ["hierarchyUsers"],
      //   transformResponse: (res) => res,
      keepUnusedDataFor: 180,
    }),
  }),
});

export const { useHierarchyUsersDataQuery } = hierarchyUsersApi;

export const userPermissionApi = createApi({
  reducerPath: "userPermissssion",
  baseQuery: baseQueryWithAuth,
  tagTypes: ["UserPermission"],
  endpoints: (builder) => ({
    getUserPermission: builder.query({
      query: (id) => `/permission/getPermissionById/${id}`,
      providesTags: ["UserPermission"],
      transformResponse: (res) => res.data,
      keepUnusedDataFor: 300,
    }),
  }),
});

export const { useGetUserPermissionQuery } = userPermissionApi;
